import * as user from './actions';

let defaultState = {
  userInfo: {}
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case user.SAVE_USERINFO:
      return {
        ...state,
        userInfo: action.userInfo
      }
    case user.MODIFY_USERINFO:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          [action.key]: action.value
        }
      }
    default:
      return state; 
  }
}
